import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../../components/auth/useAuth'
import { Link } from 'react-router-dom'

export default function Dashboard() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()

    return (
        <Container className='my-3 p-5'>
            <Row>
                <Col>
                    <h1>{clientauth?.name}, {t('admin.dashboard.welcome')}</h1>
                </Col>
            </Row>
            <Row className='mt-5'>
                <Col>
                    <Link to={`/${t("url.admin")}/${t("url.users")}`} >
                        <Card>
                            <Card.Body className='py-5 text-center'>
                                <i className='fas fa-users fa-3x'></i>
                                <h3>{t('users.users')}</h3>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
}